import { render } from "./WinnerGallery.vue?vue&type=template&id=f7599a6c&ts=true"
import script from "./WinnerGallery.vue?vue&type=script&lang=ts"
export * from "./WinnerGallery.vue?vue&type=script&lang=ts"

import "./WinnerGallery.vue?vue&type=style&index=0&id=f7599a6c&lang=less"

import exportComponent from "/Users/agtalpai/Munka/hba/hba-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__